
export const USER_LOADING = 'USER_LOADING';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const SHOW_MODAL_FORM = 'SHOW_LOGIN_FORM';
export const HIDE_MODAL_FORM = 'HIDE_LOGIN_FORM';

export const FETCH_POSTS = 'FETCH_POSTS';
export const FETCH_POST = 'FETCH_POST';

export const FETCH_ADVANTAGES = 'FETCH_ADVANTAGES';

export const FETCH_REVIEWS = 'FETCH_REVIEWS';
export const NEW_REVIEW = 'NEW_REVIEW';

export const FETCH_CARCATS = 'FETCH_CARCATS';
export const FETCH_CARCAT = 'FETCH_CARCAT';
export const FETCH_CARS = 'FETCH_CARS';
export const FETCH_CAR = 'FETCH_CAR';

export const FETCH_TEHCATS = 'FETCH_TEHCATS';
export const FETCH_TEHCAT = 'FETCH_TEHCAT';
export const FETCH_TEHS = 'FETCH_TEHS';
export const FETCH_TEH = 'FETCH_TEH';

export const FETCH_LOGOTYPES = 'FETCH_LOGOTYPES';